import { AVAILABLE_PER_DIEM_YEARS } from "@finway-group/shared/lib/consts/perDiem"
import { type PerDiemDestination } from "@finway-group/shared/lib/models"
import { type ActionCreator, type Dispatch } from "redux"
import { ExpenseHttpService } from "~Shared/services"
import { type ThunkResult } from "~Shared/store"
import { type FetchPerDiemDestinationAction, PerDiemDestinationActionTypes } from "~Shared/store/actions/perDiemDestination/perDiemDestinationTypes"

export const fetchPerDiemDestinations: ActionCreator<ThunkResult<Array<PerDiemDestination>>> = () => async (dispatch: Dispatch) => {
    const data = await ExpenseHttpService.fetchPerDiemDestinationRates(AVAILABLE_PER_DIEM_YEARS)
    const action: FetchPerDiemDestinationAction = {
        type: PerDiemDestinationActionTypes.FETCH_PER_DIEM_DESTINATIONS,
        perDiemDestinations: data,
    }
    dispatch(action)
    return data
}
